resourcePaths = '{"rootPath":"","assetsPath":""}';/* ------------------------------------------------ Mogo UI Components ------------------------------------------------ */

/* ---------------------------------------------- Mogo UI Configuration ----------------------------------------------- */

window.mogo = window.mogo || {};
window.mogo.registry = window.mogo.registry || {};
window.mogo.registry.mogoUI = window.mogo.registry.mogoUI || {};
window.mogo.registry.mogoUI.config = window.mogo.registry.mogoUI.config || {};
window.mogo.registry.mogoUI.config.mediaQueries = {
  small: 640,
  medium: 1023,
  large: 1439,
  xlarge: 9999999999
};
window.mogo.registry.mogoUI.config.blAcceptHeader = 'application/vnd.mogo.v1';
window.mogo.registry.mogoUI.config.apiAcceptHeader = 'application/vnd.mogo.v2';
window.mogo.registry.mogoUI.config.mockServiceConfigs = null;
window.mogo.registry.mogoUI.config.resourcePaths = JSON.parse(resourcePaths) || {rootPath: '', assetsPath: ''};
delete window.resourcePaths;

// Config options
window.mogo.registry.mogoUI.version = '{{mogo_ui_version_token}}'; // replaced at build time
window.mogo.registry.mogoUI.config['X-Mogo-Client'] = 'web-v' + window.mogo.registry.mogoUI.version;

/* -------------------------------------------------- Mogo UI Plugin -------------------------------------------------- */
window.mogo.registry.parseStatus = 'open';
window.mogo.registry.parseQueue = new Array();
window.mogo.registry.initialized = false;
window.mogo.registry.readyQueue = new Array();
window.mogo = window.mogo || {};
window.mogo.registry = window.mogo.registry || {};
window.mogo.registry.mogoUI = window.mogo.registry.mogoUI || {};
window.mogo.registry.mogoUI.repo = window.mogo.registry.mogoUI.repo || {};
window.mogo.repository = function () {
  return window.mogo.registry.mogoUI.repo;
};
window.mogo.ready = function (fn) {
  if (window.mogo.registry.initialized && window.mogo.registry.parseStatus == 'open') fn();
  else window.mogo.registry.readyQueue.push(fn);
};
window.mogo.parseNextInLine = function () {
  // Function use to check for queued parsing processes
  if (window.mogo.registry.parseStatus != 'open' || window.mogo.registry.parseQueue.length <= 0) {
    if (window.mogo.registry.parseStatus == 'open' && window.mogo.registry.parseQueue.length <= 0) {
      window.mogo.registry.initialized = true;

      while (window.mogo.registry.readyQueue.length > 0) {
        var fn = window.mogo.registry.readyQueue.shift();
        fn();
      }
    }
    return;
  }

  var nextInLine = window.mogo.registry.parseQueue.shift();
  if (nextInLine instanceof Node) nextInLine.mogo().parse();
  else {
    nextInLine.node.mogo().create.apply(nextInLine.node.mogo(), nextInLine.args);
  }
};

$.fn.mogo = HTMLElement.prototype.mogo = function () {
  var node = this.nodeType ? this : this[0];

  // Look up in registry, return mogo component instance if exists
  try {
    if (
      node.getAttribute('id') != null &&
      window.mogo.registry.mogoUI.repo[node.getAttribute('id')] != undefined
    ) { return window.mogo.registry.mogoUI.repo[node.getAttribute('id')]; }
  } catch (e) {
    console.error(e);
    return;
  }

  // Function used to extend classes
  var extendClasses = function (currentClass, baseClass, rootClass) {
    var extendedClass = new baseClass();
    if (extendedClass.extends) {
      for (var i = 0; i < extendedClass.extends.length; i++) {
        extendedClass = extendClasses(extendedClass, extendedClass.extends[i], rootClass);
      }
    }
    for (var name in extendedClass) {
      if (currentClass[name] == undefined) {
        if (name == 'extends' && typeof extendedClass[name] === 'object') {
        } else {
          currentClass[name] = extendedClass[name];
        }
      } else {
        if (typeof currentClass[name] === 'function' && typeof extendedClass[name] === 'function') {
          // Create subclass and base class functions with object scope
          var subFn = currentClass[name].bind(rootClass);
          var baseFn = extendedClass[name].bind(rootClass);
          var newFn = (function (name, baseFn, subFn) {
            return function () {
              this._super = (function (baseFn) {
                return function () {
                  var args = arguments;
                  return baseFn.apply(this, args);
                };
              })(baseFn);
              var _v = subFn.apply(this, arguments);
              this._super = undefined;
              return _v;
            };
          })(name, baseFn, subFn);
          currentClass[name] = newFn;
        }
      }
    }
    return currentClass;
  };

  // Function to convert string to Javascript value
  // from jQuery (https://github.com/jquery/jquery/blob/master/src/data.js)
  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/;
  var getData = function (data) {
    if (data === 'true') return true;
    if (data === 'false') return false;
    if (data === 'null') return null;
    // Only convert to a number if it doesn't change the string
    if (data === +data + '') return +data;

    if (rbrace.test(data)) {
      try {
        return JSON.parse(data);
      } catch (e) {}
    }

    return data;
  };

  // Function used to create instances (does not initialize)
  var createInstance = function (_node, args) {
    var id = _node.getAttribute('id');
    if (args[1] && args[1].id != null && args[1].id.trim() != '') id = args[1].id;
    var index = 0;
    while (id == null || id == '') {
      var tempId = args[0] + '_' + index;
      if (!document.getElementById(tempId)) id = tempId;
      index++;
    }
    _node.setAttribute('id', id);
    var objType = args[0];
    args[0] = _node;

    var construct = function (objType, args1) {
      var constructor = window[objType];
      eval('function ' + objType + '() {return constructor.apply(this, [args1]);}');

      window[objType].prototype = constructor.prototype;
      return new window[objType]();
    };
    // Construct class instance
    window.mogo.registry.mogoUI.repo[id] = construct(objType, args[0]);

    // Apply default properties
    _node.setAttribute('data-mogo-' + args[2], objType);
    window.mogo.registry.mogoUI.repo[id].id = id;
    window.mogo.registry.mogoUI.repo[id].declaredClass = objType;
    window.mogo.registry.mogoUI.repo[id].declaredType = 'MogoUIComponent';
    if (args[2] == 'page') window.mogo.registry.mogoUI.repo[id].declaredType = 'MogoUIPage';
    window.mogo.registry.mogoUI.repo[id].node = _node;
    if (window.mogo.registry.mogoUI.repo[id].priority == null) {
      if (args[2] == 'page') window.mogo.registry.mogoUI.repo[id].priority = 2000;
      else window.mogo.registry.mogoUI.repo[id].priority = 1000;
    }

    // Apply default methods
    var destroyFn = null;
    if (typeof window.mogo.registry.mogoUI.repo[id].destroy === 'function') {
      destroyFn = window.mogo.registry.mogoUI.repo[id].destroy.bind(
        window.mogo.registry.mogoUI.repo[id]
      );
    }
    window.mogo.registry.mogoUI.repo[id].destroy = function (df) {
      // Run inherited method
      if (df != null) df();
      // Destroy children
      var children = this.node.querySelectorAll('[data-mogo-ui],[data-mogo-page]');
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (document.documentElement.contains(child)) child.mogo().destroy();
      }

      this.node.parentNode.removeChild(this.node);
      delete window.mogo.registry.mogoUI.repo[id];
    }.bind(window.mogo.registry.mogoUI.repo[id], destroyFn);

    // Apply parameters
    if (args[1] != null) {
      var argsObj = args[1];
      for (var key in argsObj) {
        window.mogo.registry.mogoUI.repo[id][key] = argsObj[key];
      }
    }

    // Extend classes
    var extendedClasses = window.mogo.registry.mogoUI.repo[id].extends;
    if (extendedClasses != null) {
      for (var i = 0; i < extendedClasses.length; i++) {
        window.mogo.registry.mogoUI.repo[id] = extendClasses(
          window.mogo.registry.mogoUI.repo[id],
          extendedClasses[i],
          window.mogo.registry.mogoUI.repo[id]
        );

        var extendedClassName = extendedClasses[i].name;
        if (typeof extendedClasses[i] === 'function') {
          extendedClasses[i] = extendedClassName;
        }
      }
    }

    return window.mogo.registry.mogoUI.repo[id];
  };

  // Object returned when calling mogo() on a node that has not been initialized
  var obj = {
    _node: node,
    // Function to create a mogo component instance from the selected node
    create: function () {
      if (window.mogo.registry.parseStatus != 'open') {
        var n = this._node;
        window.mogo.registry.parseQueue.push({node: n, args: arguments});
        return;
      }
      window.mogo.registry.parseStatus = 'parsing';
      if (arguments.length === 0) {
        return;
      } else if (typeof arguments[0] === 'string') {
        if (arguments.length === 1) {
          arguments[1] = null;
          arguments[2] = 'ui';
        } else if (arguments[2] == null) arguments[2] = 'ui';
      }

      var comp = createInstance(this._node, arguments);

      // Init component
      if (document.readyState != 'complete') {
        window.mogo.registry.mogoUI.repo[comp.id].init();
        window.addEventListener(
          'load',
          function (comp) {
            // In case of page redirection
            if (window.mogo.registry.mogoUI.repo[comp.id])
              comp.initAllReady();
            window.mogo.registry.parseStatus = 'open';
            window.mogo.parseNextInLine();
          }.bind(null, comp)
        );
      } else {
        window.mogo.registry.mogoUI.repo[comp.id].init();
        // In case of page redirection
        if (window.mogo.registry.mogoUI.repo[comp.id])
          window.mogo.registry.mogoUI.repo[comp.id].initAllReady();
        window.mogo.registry.parseStatus = 'open';
        window.mogo.parseNextInLine();
      }
      return comp;
    },
    // Function to parse (create instance and initialize) all mogo components from the selected node
    // type: type of components to parse, defaults to all; page or ui
    parse: function (type) {
      if (window.mogo.registry.parseStatus != 'open') {
        window.mogo.registry.parseQueue.push(this._node);
        return;
      }
      window.mogo.registry.parseStatus = 'parsing';
      if (type) {
        if (type === 'page') type = '[data-mogo-page]';
        else type = '[data-mogo-ui]';
      }
      var mogoComponents = this._node.querySelectorAllAndSelf(
        type || '[data-mogo-ui],[data-mogo-page]'
      );
      var createdInstances = new Array();
      for (var i = 0; i < mogoComponents.length; i++) {
        var className = mogoComponents[i].dataset['mogoUi'];
        var declaredType = 'mogoUi';
        if (className == null) {
          className = mogoComponents[i].dataset['mogoPage'];
          declaredType = 'mogoPage';
        }
        var params = {};
        var dataObj = mogoComponents[i].dataset;
        for (var key in dataObj) {
          if (key.indexOf(declaredType) == 0) {
            var prop = key.replace(declaredType, '');
            if (prop != '') {
              prop = prop.substring(0, 1).toLowerCase() + prop.substring(1);
              params[prop] = getData(dataObj[key]);
            }
          }
        }
        if (mogoComponents[i].mogo().create) {
          var comp = createInstance(mogoComponents[i], [
            className,
            params,
            declaredType.replace('mogo', '').toLowerCase()
          ]);
          createdInstances.push(comp);
        } else { console.error('mogoUI: error: id ' + mogoComponents[i].mogo().id + ' already exists'); }
      }

      // Sort components
      createdInstances.sort(function (a, b) {
        return a.priority - b.priority;
      });

      // Initialize components
      for (var i = 0; i < createdInstances.length; i++) {
        createdInstances[i].init();
      }
      if (document.readyState != 'complete') {
        window.addEventListener(
          'load',
          function (arr) {
            for (var i = 0; i < arr.length; i++) {
              arr[i].initAllReady();
            }
            window.mogo.registry.parseStatus = 'open';
            window.mogo.parseNextInLine();
          }.bind(null, createdInstances)
        );
      } else {
        for (var i = 0; i < createdInstances.length; i++) {
          createdInstances[i].initAllReady();
        }
        window.mogo.registry.parseStatus = 'open';
        window.mogo.parseNextInLine();
      }
    },
    // Function to destroy all mogo components and pages under given node
    destroy: function () {
      var mogoComponents = this._node.querySelectorAllAndSelf('[data-mogo-ui],[data-mogo-page]');
      for (var i = 0; i < mogoComponents.length; i++) {
        if (typeof mogoComponents[i].mogo().create === 'undefined') {
          mogoComponents[i].mogo().destroy();
        }
      }
      if (this._node && this._node.parentNode) {
        this._node.parentNode.removeChild(this._node);
      } // double check if needed
    }
  };

  // Mogo component does not exist, return obj
  return obj;
};

/* ------------------------------------------------ Mogo UI Initializer ----------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var _html = document.getElementsByTagName('html')[0];

  // Android stock detection
  var rxaosp = window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);
  if (rxaosp && rxaosp[1] < 537) {
    _html.addClass('android-stock');
  }

  _html.mogo().parse();
});
